import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kingOfPrussiaConfig } from "./data";

export default function KingOfPrussiaPage() {
  return <CityPageTemplate config={kingOfPrussiaConfig} />;
}